import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Discipline } from "src/app/shared/models/discipline";

@Injectable({
  providedIn: "root",
})
export class DisciplineService {
  constructor(private http: HttpClient) {}

  apiRoot = `${environment.apiUrl}Discipline`;

  public createDiscipline(
    code: string,
    description: string
  ): Observable<Discipline> {
    return this.http.post<Discipline>(
      `${this.apiRoot}/createDiscipline/code=${code}/description=${description}`,
      null
    );
  }

  public getDiscipline(code: string): Observable<Discipline> {
    return this.http.get<Discipline>(`${this.apiRoot}/getDiscipline/${code}`);
  }

  public getAllDisciplines(): Observable<Discipline[]> {
    return this.http.get<Discipline[]>(`${this.apiRoot}/getAllDisciplines`);
  }

  public deleteDiscipline(code: string): Observable<Discipline> {
    return this.http.delete<Discipline>(
      `${this.apiRoot}/deleteDiscipline/${code}`
    );
  }
}
